var popupsId = [
    {
        selector: 'appointment-new-form',
        title: 'Заявка перезвонить'
    },
    {
        selector: 'appointment-form',
        title: 'Запись на прием'
    },
    {
        selector: 'callback-form',
        title: 'Обратный звонок'
    },
    {
        selector: 'feedback-form',
        title: 'Обратная связь'
    },
    {
        selector: 'pay-form',
        title: 'Задать вопрос'
    },
    {
        selector: 'qa-form',
        title: 'Задать вопрос'
    },
    {
        selector: 'add-testimonial-form',
        title: 'Добавить отзыв'
    },
    {
        selector: 'appointment-form-confirm',
        title: 'Подтвердить данные для записи на прием'
    },
]

function getCalltouchParams() {
    if (typeof window.ct === 'function' && Array.isArray(window.ct('calltracking_params')) && window.ct('calltracking_params').length) {
        return window.ct('calltracking_params')[0]
    }
}

function getSiteId() {
    const calltouchParams = getCalltouchParams()
    if (!calltouchParams) {
        return
    }
    return calltouchParams.siteId
}

function getSessionId() {
    const calltouchParams = getCalltouchParams()
    if (!calltouchParams) {
        return
    }
    return calltouchParams.sessionId
}

function checkFormForCalltouch(formEl, dataForm, conversionData) {
    if (!window.CalltouchDataObject || !getCalltouchParams()) {
        return;
    }
    var data = null;
    for (var i = 0; i < popupsId.length; i++) {
        if (!formEl) return

        if (conversionData) {
            data = Object.fromEntries(dataForm.entries());
        } else {
            data = dataForm;
        }

        if (formEl.closest("aside[id='" + popupsId[i].selector + "']")) {
            var ct_data = {
                fio: data.name || '',
                phoneNumber: data.phone || '',
                email: data.email || '',
                subject: popupsId[i].title || '',
                comment: data.question || data.message || '',
                requestUrl: location.href,
                sessionId: getSessionId()
            };
            jQuery.ajax({
                url: "https://api.calltouch.ru/calls-service/RestAPI/requests/" + getSiteId() + "/register/",
                dataType: 'json',
                type: 'POST',
                data: ct_data
            });
            return
        }
    }
}
